import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';
import styles from './Stack.module.css';

export type StackGap = 1 | 2 | 3 | 4 | 5 | 6;
export type StackDirection = 'column' | 'row';
export type StackAlign = 'start' | 'center' | 'stretch';
export type StackJustify = 'start' | 'between';

export type StackProps = HTMLAttributes<HTMLDivElement> & {
  direction?: StackDirection;
  gap?: StackGap;
  align?: StackAlign;
  justify?: StackJustify;
  children?: ReactNode;
};

export function Stack({
  direction = 'column',
  gap = 3,
  align = 'stretch',
  justify = 'start',
  className,
  children,
  ...rest
}: StackProps) {
  return (
    <div
      className={cn(
        styles.root,
        direction === 'column' ? styles.dir_col : styles.dir_row,
        styles[`gap_${gap}`],
        styles[`align_${align}`],
        styles[`justify_${justify}`],
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
